import type { SpeciesSummary } from '@api/types'

// Para comparar sin tildes ni mayúsculas: "Castilla-La Mancha" y "castilla la mancha" coinciden.
export const normalizeSearch = (text: string): string =>
	text
		.normalize('NFD')
		.replace(/[̀-ͯ]/g, '')
		.toLowerCase()
		.replace(/[^a-z0-9ñ]+/g, ' ')
		.trim()

// Busca en varios campos a la vez: nombre común, nombre científico y comunidades donde se planta.
// Cada palabra de la búsqueda tiene que aparecer en alguno (en cualquier orden): "encina murcia"
// da las encinas que se plantan en Murcia. Sin palabras, todas. Conserva el orden de entrada.
export const searchSpecies = (
	species: readonly SpeciesSummary[],
	query: string,
	regionName: (id: string) => string
): SpeciesSummary[] => {
	const words = normalizeSearch(query).split(' ').filter(Boolean)
	if (words.length === 0) return [...species]
	return species.filter((item) => {
		const haystack = normalizeSearch(
			[item.commonName, item.scientificName, ...item.regionIds.map(regionName)].join(' ')
		)
		return words.every((word) => haystack.includes(word))
	})
}
